// src/analytics.js
export const track = (opts) => {
  /* istanbul ignore next */
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    /* istanbul ignore next */
    window.LIFE_CYCLE_EVENT_BUS.trigger('educational-summary.click', opts);
  }
};
